(() => {
  var e = {
      556: (e, t, n) => {
        e.exports = n(694)();
      },
      694: (e, t, n) => {
        "use strict";

        var r = n(925);
        function o() {}
        function i() {}
        i.resetWarningCache = o, e.exports = function () {
          function e(e, t, n, o, i, a) {
            if (a !== r) {
              var c = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
              throw c.name = "Invariant Violation", c;
            }
          }
          function t() {
            return e;
          }
          e.isRequired = e;
          var n = {
            array: e,
            bigint: e,
            bool: e,
            func: e,
            number: e,
            object: e,
            string: e,
            symbol: e,
            any: e,
            arrayOf: t,
            element: e,
            elementType: e,
            instanceOf: t,
            node: e,
            objectOf: t,
            oneOf: t,
            oneOfType: t,
            shape: t,
            exact: t,
            checkPropTypes: i,
            resetWarningCache: o
          };
          return n.PropTypes = n, n;
        };
      },
      925: e => {
        "use strict";

        e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
      }
    },
    t = {};
  function n(r) {
    var o = t[r];
    if (void 0 !== o) return o.exports;
    var i = t[r] = {
      exports: {}
    };
    return e[r](i, i.exports, n), i.exports;
  }
  n.n = e => {
    var t = e && e.__esModule ? () => e.default : () => e;
    return n.d(t, {
      a: t
    }), t;
  }, n.d = (e, t) => {
    for (var r in t) n.o(t, r) && !n.o(e, r) && Object.defineProperty(e, r, {
      enumerable: !0,
      get: t[r]
    });
  }, n.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t), n.r = e => {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  };
  var r = {};
  (() => {
    "use strict";

    n.r(r), n.d(r, {
      AnglePicker: () => le,
      GRADIENT_TYPES: () => Le,
      GradientPicker: () => Fe,
      GradientPickerPopover: () => Ye,
      getGradientPreview: () => k
    });
    var e = function (e, t) {
      return e.offset - t.offset;
    };
    const t = function (t) {
      return t.sort(e);
    };
    const o = function () {};
    const i = function (e) {
      return e < (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0) ? 360 + e : e > (arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 360) ? e - 360 : e;
    };
    const a = function (e) {
      if (!e) return {
        y: 0,
        x: 0
      };
      var t = e.getBoundingClientRect(),
        n = t.top,
        r = t.left;
      return {
        y: n + t.height / 2,
        x: r + t.width / 2
      };
    };
    const c = function (e, t, n) {
      var r = t - n.y,
        o = e - n.x,
        i = Math.atan2(r, o);
      return Math.round(i * (180 / Math.PI)) + 90;
    };
    const u = function (e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
        n = e % t;
      return 0 === n ? e : e + (n > t / 2 ? t - n : -1 * n);
    };
    const l = function (e) {
      var t = e.r,
        n = e.g,
        r = e.b,
        o = e.a,
        i = void 0 === o ? 1 : o;
      return 1 !== i ? "rgba(".concat(t, ", ").concat(n, ", ").concat(r, ", ").concat(i, ")") : "rgb(".concat(t, ", ").concat(n, ", ").concat(r, ")");
    };
    function s(e) {
      if (Array.isArray(e)) return e;
    }
    function f(e) {
      if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
    }
    function d(e, t) {
      (null == t || t > e.length) && (t = e.length);
      for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
      return r;
    }
    function p(e, t) {
      if (e) {
        if ("string" == typeof e) return d(e, t);
        var n = {}.toString.call(e).slice(8, -1);
        return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? d(e, t) : void 0;
      }
    }
    function v() {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var m = new RegExp(/\d+/g),
      g = function (e) {
        return Number(e);
      };
    const y = function (e) {
      var t = function (e) {
          return s(e) || f(e) || p(e) || v();
        }(e.match(m)),
        n = t[0],
        r = t[1],
        o = t[2],
        i = t.slice(3).join(".") || 1;
      return function (e, t, n, r) {
        return [e, t, n].every(function (e) {
          return e >= 0 && e <= 255;
        }) && (!r || r >= 0 && r <= 1);
      }(n, r, o, i) ? {
        r: g(n),
        g: g(r),
        b: g(o),
        a: g(i)
      } : void 0;
    };
    var b = new RegExp(/^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i),
      h = new RegExp(/^#?([a-f\d])([a-f\d])([a-f\d])$/i),
      O = function (e) {
        return parseInt(e.repeat(3 - e.length), 16);
      };
    const E = function (e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1,
        n = b.exec(e) || h.exec(e);
      return n ? {
        r: O(n[1]),
        g: O(n[2]),
        b: O(n[3]),
        a: t
      } : void 0;
    };
    var w = [{
      regexps: [b, h],
      handler: E
    }, {
      regexps: [m],
      handler: y
    }];
    const S = function (e, t) {
      var n = w.find(function (t) {
        return t.regexps.some(function (t) {
          return t.test(e);
        });
      });
      if (!n) throw new Error("Stop color - ".concat(e, " does not follow one of the accepted formats Hex / Rgb / Rgba "));
      var r = n.handler(e, t);
      return l(r);
    };
    const R = function (e) {
      return (e = e.toString().trim()).endsWith("%") ? Number(e.replace("%", "")) : 100 * Number(e);
    };
    var P = 360,
      T = Math.pow(2, -52),
      j = function (e) {
        return e <= 0 || Math.abs(e) <= T ? 0 : e;
      },
      C = function (e) {
        return {
          x: j(Math.cos(e)),
          y: j(Math.sin(e))
        };
      },
      A = function (e) {
        return e * Math.PI / 180;
      };
    const D = function () {
      var e = (P - (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0)) % P,
        t = C(A(90 - e)),
        n = C(A(270 - e));
      return {
        x1: t.x,
        y1: t.y,
        x2: n.x,
        y2: n.y
      };
    };
    const k = function (e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 90,
        n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "linear",
        r = D(t),
        o = function (e) {
          var t = e.angle,
            n = e.stops,
            r = e.type,
            o = "linear" === r ? "".concat(t, "deg, ") : "";
          return 1 === n.length ? n[0].color : "".concat(r, "-gradient(").concat(o).concat(n.map(function (e) {
            return "".concat(e.color, " ").concat(e.offset, "%");
          }).join(", "), ")");
        }({
          angle: t,
          stops: e.map(function (e) {
            var t = e.offset,
              n = e.color,
              r = e.opacity;
            return {
              offset: R(t),
              color: S(n, r)
            };
          }),
          type: n
        });
      return {
        gradient: r,
        background: o,
        angle: t
      };
    };
    function N(e, t) {
      return s(e) || function (e, t) {
        var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
        if (null != n) {
          var r,
            o,
            i,
            a,
            c = [],
            u = !0,
            l = !1;
          try {
            if (i = (n = n.call(e)).next, 0 === t) {
              if (Object(n) !== n) return;
              u = !1;
            } else for (; !(u = (r = i.call(n)).done) && (c.push(r.value), c.length !== t); u = !0);
          } catch (e) {
            l = !0, o = e;
          } finally {
            try {
              if (!u && null != n.return && (a = n.return(), Object(a) !== a)) return;
            } finally {
              if (l) throw o;
            }
          }
          return c;
        }
      }(e, t) || p(e, t) || v();
    }
    const x = require("react");
    var I = n.n(x);
    function q(e) {
      return q = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      }, q(e);
    }
    function F(e) {
      var t = function (e, t) {
        if ("object" != q(e) || !e) return e;
        var n = e[Symbol.toPrimitive];
        if (void 0 !== n) {
          var r = n.call(e, t || "default");
          if ("object" != q(r)) return r;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return ("string" === t ? String : Number)(e);
      }(e, "string");
      return "symbol" == q(t) ? t : t + "";
    }
    function L(e, t, n) {
      return (t = F(t)) in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }
    var M = n(556),
      H = n.n(M),
      _ = {
        HORIZONTAL: "horizontal",
        VERTICAL: "vertical"
      },
      G = _.HORIZONTAL,
      Z = "color-picker",
      Y = [".".concat(Z), ".".concat("gp", " .").concat("csh")],
      X = {
        STATIC: "static",
        POPOVER: "popover"
      },
      U = X.STATIC;
    function B(e, t) {
      var n = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function z(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? B(Object(n), !0).forEach(function (t) {
          L(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : B(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }
      return e;
    }
    var V = (0, M.shape)({
        id: M.number.isRequired,
        color: M.string.isRequired,
        offset: M.number.isRequired,
        isActive: M.bool.isRequired,
        pointX: M.number
      }),
      W = (0, M.shape)({
        min: M.number.isRequired,
        max: M.number.isRequired,
        drop: M.number
      }),
      $ = (0, M.shape)({
        id: M.number,
        color: M.string.isRequired,
        offset: M.string.isRequired,
        opacity: M.number
      }),
      J = Object.values(_),
      K = Object.values(X),
      Q = {
        stop: V.isRequired,
        limits: W.isRequired,
        onPosChange: M.func.isRequired,
        onDeleteColor: M.func.isRequired,
        onDragStart: M.func,
        onDragEnd: M.func
      },
      ee = {
        width: M.number.isRequired,
        stops: (0, M.arrayOf)(V),
        limits: W,
        disabled: M.bool,
        onPosChange: M.func.isRequired,
        onAddColor: M.func.isRequired,
        onDeleteColor: M.func.isRequired,
        onDragStart: M.func,
        onDragEnd: M.func,
        direction: (0, M.oneOf)(J)
      },
      te = {
        width: M.number.isRequired,
        height: M.number.isRequired,
        palette: (0, M.arrayOf)($).isRequired,
        direction: (0, M.oneOf)(J)
      },
      ne = {
        onPaletteChange: M.func.isRequired,
        paletteHeight: M.number,
        width: M.number,
        stopRemovalDrop: M.number,
        maxStops: M.number,
        minStops: M.number,
        flatStyle: M.bool,
        palette: (0, M.arrayOf)($),
        direction: (0, M.oneOf)(J),
        colorPickerMode: (0, M.oneOf)(K)
      },
      re = {
        angle: M.number.isRequired,
        setAngle: M.func.isRequired,
        size: M.number,
        snap: M.number
      },
      oe = z(z(z({}, ne), re), {}, {
        showAnglePicker: M.bool,
        showGradientTypePicker: M.bool,
        open: M.bool.isRequired,
        setOpen: M.func.isRequired,
        trigger: M.func
      }),
      ie = "touchstart",
      ae = {
        MOUSE: {
          stop: function (e) {
            e.preventDefault(), e.stopPropagation();
          },
          coordinates: function (e) {
            return {
              clientX: e.clientX,
              clientY: e.clientY
            };
          },
          dragEvent: {
            name: "mousemove"
          },
          dragEndEvent: {
            name: "mouseup"
          }
        },
        TOUCH: {
          stop: o,
          coordinates: function (e) {
            var t = N(e.touches, 1)[0];
            return {
              clientX: t.clientX,
              clientY: t.clientY
            };
          },
          dragEvent: {
            name: "touchmove",
            options: {
              cancelable: !0,
              passive: !0
            }
          },
          dragEndEvent: {
            name: "touchend"
          }
        }
      };
    const ce = function (e) {
      var t = e.onDragStart,
        n = void 0 === t ? o : t,
        r = e.onDrag,
        i = e.onDragEnd,
        a = void 0 === i ? o : i,
        c = N((0, x.useState)({}), 2),
        u = c[0],
        l = c[1],
        s = N((0, x.useState)(!1), 2),
        f = s[0],
        d = s[1],
        p = function (e, t) {
          d(!0), u.handler = t, n(t.coordinates(e));
        },
        v = function () {
          d(!1), a(u.change), l({});
        },
        m = function (e) {
          var t = u.handler;
          f && (u.change = r(t.coordinates(e)));
        };
      return (0, x.useEffect)(function () {
        var e = u.handler;
        if (e) {
          var t = e.dragEvent,
            n = e.dragEndEvent;
          return f && (document.addEventListener(t.name, m, n.options), document.addEventListener(n.name, v)), function () {
            document.removeEventListener(t.name, m, n.options), document.removeEventListener(n.name, v);
          };
        }
      }, [f]), [function (e) {
        var t = function (e) {
          return e.type === ie;
        }(e) ? ae.TOUCH : ae.MOUSE;
        t.stop(e), e.button || p(e, t);
      }, p, v];
    };
    var ue = function (e) {
      var t = e.angle,
        n = e.setAngle,
        r = e.size,
        o = void 0 === r ? 24 : r,
        l = e.snap,
        s = void 0 === l ? 5 : l,
        f = (0, x.useRef)(),
        d = {
          height: o,
          width: o
        },
        p = function (e) {
          var t = e.clientX,
            r = e.clientY,
            o = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
            l = a(f.current),
            d = c(t, r, l),
            p = i(d),
            v = o ? u(p, s) : p;
          n(v);
        },
        v = ce({
          onDragStart: function (e) {
            return p(e, !0);
          },
          onDrag: p,
          onDragEnd: function (e) {
            if (e) {
              var t = u(e, s);
              n(t);
            }
          }
        }),
        m = N(v, 1)[0];
      return I().createElement(I().Fragment, null, I().createElement("div", {
        className: "ap",
        ref: f,
        onMouseDown: m,
        onTouchStart: m,
        style: d
      }, I().createElement("span", {
        className: "apc",
        style: {
          transform: "rotate(".concat(t, "deg)"),
          height: o
        }
      }, I().createElement("i", {
        className: "aph"
      }))), I().createElement("div", {
        className: "ai"
      }, I().createElement("span", {
        onClick: function () {
          return n(t - 1);
        }
      }, "−"), I().createElement("input", {
        value: "".concat(t, "°"),
        disabled: !0
      }), I().createElement("span", {
        onClick: function () {
          return n(t + 1);
        }
      }, "+")));
    };
    ue.propTypes = re;
    const le = ue;
    function se(e, t) {
      if (null == e) return {};
      var n,
        r,
        o = function (e, t) {
          if (null == e) return {};
          var n = {};
          for (var r in e) if ({}.hasOwnProperty.call(e, r)) {
            if (-1 !== t.indexOf(r)) continue;
            n[r] = e[r];
          }
          return n;
        }(e, t);
      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);
        for (r = 0; r < i.length; r++) n = i[r], -1 === t.indexOf(n) && {}.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
      }
      return o;
    }
    function fe(e) {
      return function (e) {
        if (Array.isArray(e)) return d(e);
      }(e) || f(e) || p(e) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }
    function de() {
      return de = Object.assign ? Object.assign.bind() : function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];
          for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
      }, de.apply(null, arguments);
    }
    var pe = function (e, t, n) {
      var r = e === _.HORIZONTAL ? t.clientY : t.clientX,
        o = function (e, t) {
          if (!e.current) return 0;
          var n = e.current.getBoundingClientRect();
          return t === _.HORIZONTAL ? n.top : n.left;
        }(n, e);
      return Math.abs(r - o);
    };
    const ve = function (e) {
      var t = e.limits,
        n = e.stop,
        r = e.initialPos,
        o = e.colorStopRef,
        i = e.onPosChange,
        a = e.onDragStart,
        c = e.onDragEnd,
        u = e.onDeleteColor,
        l = e.direction,
        s = N((0, x.useState)(r), 2),
        f = s[0],
        d = s[1];
      return [N(ce({
        onDragStart: function (e) {
          var t = e.clientX,
            r = e.clientY;
          d(l === _.HORIZONTAL ? t : r), a(n.id);
        },
        onDrag: function (e) {
          var r = n.id,
            a = n.offset,
            c = t.min,
            s = t.max,
            d = a - f;
          if (pe(l, e, o) > t.drop) return u(r);
          var p = function (e, t, n) {
            return Math.max(Math.min(e, n), t);
          }(d + (l === _.HORIZONTAL ? e.clientX : e.clientY), c, s);
          i({
            id: r,
            offset: p
          });
        },
        onDragEnd: function () {
          return c(n.id);
        }
      }), 1)[0]];
    };
    var me = function (e) {
      var t = e.stop,
        n = e.limits,
        r = e.onPosChange,
        i = e.onDeleteColor,
        a = e.onDragStart,
        c = void 0 === a ? o : a,
        u = e.onDragEnd,
        l = void 0 === u ? o : u,
        s = e.direction,
        f = (0, x.useRef)(),
        d = N((0, x.useState)(!1), 2),
        p = d[0],
        v = d[1],
        m = N(ve({
          stop: t,
          limits: n,
          onPosChange: r,
          onDragStart: c,
          onDragEnd: l,
          onDeleteColor: i,
          colorStopRef: f,
          direction: s
        }), 1)[0];
      (0, x.useEffect)(function () {
        setTimeout(function () {
          return v(!0);
        }, 500);
      }, []);
      var g = t.offset,
        y = t.color,
        b = t.isActive,
        h = t.opacity;
      return I().createElement("div", {
        className: "cs ".concat(s, " ").concat(b ? "active" : ""),
        ref: f,
        style: s === _.HORIZONTAL ? {
          left: g
        } : {
          top: g
        },
        onMouseDown: m,
        onDoubleClick: function () {
          p && i(t.id);
        },
        onTouchStart: m
      }, I().createElement("div", {
        style: {
          backgroundColor: y,
          opacity: h
        }
      }));
    };
    me.propTypes = Q;
    const ge = me;
    var ye = ["width", "direction", "stops", "disabled", "onAddColor"],
      be = function (e, t, n) {
        return {
          width: n === _.HORIZONTAL ? e : 17,
          height: n === _.HORIZONTAL ? 17 : e,
          position: "relative",
          cursor: t ? "default" : "crosshair"
        };
      },
      he = function (e) {
        var t = e.width,
          n = e.direction,
          r = e.stops,
          o = e.disabled,
          i = void 0 !== o && o,
          a = e.onAddColor,
          c = se(e, ye);
        return I().createElement("div", {
          className: "csh",
          style: be(t, i, n),
          onMouseDown: function (e) {
            if (e.preventDefault(), !e.button) {
              var t = n === _.HORIZONTAL ? e.clientX - e.target.getBoundingClientRect().left : e.clientY - e.target.getBoundingClientRect().top;
              a({
                offset: t
              });
            }
          }
        }, r.map(function (e) {
          return I().createElement(ge, de({
            key: e.id,
            stop: e,
            direction: n
          }, c));
        }));
      };
    he.propTypes = ee;
    const Oe = he;
    function Ee(e, t) {
      var n = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function we(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? Ee(Object(n), !0).forEach(function (t) {
          L(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ee(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }
      return e;
    }
    var Se = function () {
        return "" + Math.random().toString(36).substr(2, 9);
      },
      Re = function (e) {
        var n = e.palette,
          r = e.width,
          o = e.height,
          i = e.direction,
          a = t(n),
          c = (0, x.useMemo)(Se, [n.length]);
        return I().createElement("div", {
          className: "palette",
          style: we({}, i === _.HORIZONTAL ? {
            width: r,
            height: o
          } : {
            width: o,
            height: r
          })
        }, I().createElement("svg", {
          width: "100%",
          height: "100%"
        }, I().createElement("defs", null, I().createElement("linearGradient", de({
          id: c
        }, i === _.HORIZONTAL ? {
          x1: 0,
          y1: .5,
          x2: 1,
          y2: .5
        } : {
          x1: .5,
          y1: 0,
          x2: .5,
          y2: 1
        }), " ", a.map(function (e) {
          var t = e.id,
            n = e.offset,
            r = e.color,
            o = e.opacity,
            i = void 0 === o ? 1 : o;
          return I().createElement("stop", {
            key: t,
            offset: n,
            style: {
              stopColor: r,
              stopOpacity: i
            }
          });
        }))), I().createElement("rect", {
          x: "0",
          y: "0",
          width: "100%",
          height: "100%",
          fill: "url(#".concat(c, ")")
        })));
      };
    Re.propTypes = te;
    const Pe = Re;
    var Te = [{
        value: "#000000",
        name: "black"
      }, {
        value: "#808080",
        name: "gray"
      }, {
        value: "#C0C0C0",
        name: "silver"
      }, {
        value: "#FFFFFF",
        name: "white"
      }, {
        value: "#FF0000",
        name: "red"
      }, {
        value: "#800000",
        name: "maroon"
      }, {
        value: "#FFFF00",
        name: "yellow"
      }, {
        value: "#808000",
        name: "olive"
      }, {
        value: "#00FF00",
        name: "lime"
      }, {
        value: "#008000",
        name: "green"
      }, {
        value: "#00FFFF",
        name: "aqua"
      }, {
        value: "#008080",
        name: "teal"
      }, {
        value: "#0000FF",
        name: "blue"
      }, {
        value: "#000080",
        name: "navy"
      }, {
        value: "#FF00FF",
        name: "fuchsia"
      }, {
        value: "#800080",
        name: "purple"
      }],
      je = function (e) {
        var t = e.onSelect;
        return I().createElement("div", {
          className: "cp"
        }, Te.map(function (e) {
          var n = e.value,
            r = e.name;
          return I().createElement("div", {
            onClick: function () {
              return t(n);
            },
            key: r,
            title: r,
            style: {
              backgroundColor: n
            }
          });
        }));
      };
    je.propTypes = {
      color: H().string.isRequired,
      onSelect: H().func.isRequired
    };
    const Ce = je;
    var Ae = ["offset", "id"];
    function De(e, t) {
      var n = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function ke(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? De(Object(n), !0).forEach(function (t) {
          L(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : De(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }
      return e;
    }
    var Ne = function (e) {
        return Math.max.apply(Math, fe(e.map(function (e) {
          return e.id;
        }))) + 1;
      },
      xe = function (e) {
        var t = e.palette,
          n = e.activeId,
          r = e.width;
        return t.map(function (e) {
          return ke(ke({}, e), {}, {
            id: e.id,
            offset: r * e.offset - 5,
            isActive: e.id === n
          });
        });
      },
      Ie = function (e, t) {
        var n = e.find(function (e) {
          return e.id === t;
        }) || e[0];
        return ke(ke({}, n), {}, {
          offset: Number(n.offset)
        });
      },
      qe = function (e) {
        var n = e.palette,
          r = e.paletteHeight,
          i = void 0 === r ? 32 : r,
          a = e.width,
          c = void 0 === a ? 220 : a,
          u = e.stopRemovalDrop,
          l = void 0 === u ? 50 : u,
          s = e.minStops,
          f = void 0 === s ? 2 : s,
          d = e.maxStops,
          p = void 0 === d ? 5 : d,
          v = e.children,
          m = e.flatStyle,
          g = void 0 !== m && m,
          y = e.onPaletteChange,
          b = e.onColorStopSelect,
          h = void 0 === b ? o : b,
          O = e.direction,
          E = void 0 === O ? G : O,
          w = e.colorPickerMode,
          S = void 0 === w ? U : w;
        n = function (e) {
          return e.map(function (e, t) {
            return ke(ke({}, e), {}, {
              id: e.id || t + 1
            });
          });
        }(n);
        var R = N(I().useState(S === X.STATIC), 2),
          P = R[0],
          T = R[1],
          j = N(n, 1)[0],
          C = N((0, x.useState)(j.id), 2),
          A = C[0],
          D = C[1],
          k = (0, x.useRef)(null),
          q = S === X.POPOVER,
          F = (0, x.useMemo)(function () {
            return {
              min: -5,
              max: c - 5,
              drop: l
            };
          }, [c]);
        !function (e) {
          var t = e.pickerRef,
            n = e.callback,
            r = e.ignoredSelectors,
            o = e.enabled;
          (0, x.useEffect)(function () {
            function e(e) {
              var o = t.current && t.current.contains(e.target),
                i = r.some(function (t) {
                  return e.target.closest(t);
                });
              o && i || n();
            }
            return o && document.addEventListener("click", e), function () {
              o && document.removeEventListener("click", e);
            };
          }, [n, r, o]);
        }({
          pickerRef: k,
          callback: (0, x.useCallback)(function () {
            return T(!1);
          }, [T]),
          ignoredSelectors: Y,
          enabled: q
        });
        var L = function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
            n = n.map(function (n) {
              return A === n.id ? ke(ke({}, n), {}, {
                color: e,
                opacity: t
              }) : n;
            }), M(n);
          },
          M = function (e) {
            var n = t(e).map(function (e) {
              var t = e.offset,
                n = e.id;
              return ke(ke({}, se(e, Ae)), {}, {
                id: n,
                offset: Number(t).toFixed(3),
                active: n === A
              });
            });
            y(n);
          },
          H = c - 5,
          _ = n.length >= p;
        return I().createElement("div", {
          ref: k,
          className: "".concat("gp", " color-picker-mode-").concat(S, " ").concat(E)
        }, I().createElement(Pe, {
          width: H,
          height: i,
          palette: n,
          direction: E
        }), I().createElement(Oe, {
          width: H,
          disabled: _,
          stops: xe({
            palette: n,
            width: H,
            activeId: A
          }),
          limits: F,
          onPosChange: function (e) {
            var t = e.id,
              r = e.offset,
              o = n.map(function (e) {
                return t === e.id ? ke(ke({}, e), {}, {
                  offset: (r + 5) / c
                }) : e;
              });
            M(o);
          },
          onAddColor: function (e) {
            var t = e.offset;
            if (!(n.length >= p)) {
              q && T(!0);
              var r = Ie(n, A).color,
                o = {
                  id: Ne(n),
                  offset: t / c,
                  color: r
                },
                i = [].concat(fe(n), [o]);
              D(o.id), M(i);
            }
          },
          onDeleteColor: function (e) {
            if (!(n.length <= f)) {
              var t = n.filter(function (t) {
                  return t.id !== e;
                }),
                r = t.reduce(function (e, t) {
                  return t.offset < e.offset ? t : e;
                }, t[0]).id;
              D(r), M(t);
            }
          },
          onDragStart: function (e) {
            if (q && T(!0), e !== A) {
              D(e);
              var t = n.find(function (t) {
                return t.id === e;
              });
              h(t);
            }
          },
          direction: E
        }), I().createElement("div", {
          className: "color-picker-wrapper"
        }, I().createElement("div", {
          className: "color-picker-wrapper-inner"
        }, P && function () {
          var e = Ie(n, A),
            t = ke(ke({
              color: e.color,
              opacity: e.opacity,
              className: Z
            }, g && {
              width: c,
              className: "gp-flat ".concat(Z)
            }), {}, {
              onSelect: L
            });
          if (!v) return I().createElement(Ce, t);
          var r = I().Children.only(v);
          return I().cloneElement(r, t);
        }())));
      };
    qe.propTypes = ne;
    const Fe = qe;
    var Le = {
        LINEAR: "linear",
        RADIAL: "radial"
      },
      Me = function (e) {
        var t = e.gradientType,
          n = e.onGradientTypeChange,
          r = t === Le.LINEAR;
        return I().createElement("span", {
          className: "type-picker-wrapper"
        }, I().createElement("span", {
          className: "type-picker lg ".concat(r ? "active" : ""),
          onClick: function () {
            return n(Le.LINEAR);
          }
        }), I().createElement("span", {
          className: "type-picker rg ".concat(r ? "" : "active"),
          onClick: function () {
            return n(Le.RADIAL);
          }
        }));
      };
    Me.propTypes = {
      gradientType: M.string,
      onGradientTypeChange: M.func
    };
    const He = Me;
    var _e = ["palette", "open", "setOpen", "trigger", "showAnglePicker", "showGradientTypePicker", "angle", "setAngle", "gradientType", "setGradientType"],
      Ge = function (e, t) {
        return I().createElement("div", {
          className: "trigger",
          onClick: t
        }, I().createElement("div", {
          className: "inner",
          style: {
            background: e
          }
        }));
      },
      Ze = function (e) {
        var t = e.palette,
          n = e.open,
          r = void 0 !== n && n,
          o = e.setOpen,
          i = e.trigger,
          a = void 0 === i ? Ge : i,
          c = e.showAnglePicker,
          u = void 0 === c || c,
          l = e.showGradientTypePicker,
          s = void 0 === l || l,
          f = e.angle,
          d = e.setAngle,
          p = e.gradientType,
          v = e.setGradientType,
          m = se(e, _e),
          g = N((0, x.useState)(Le.LINEAR), 2),
          y = g[0],
          b = g[1],
          h = p || y,
          O = v || b,
          E = k(t, f, h).background,
          w = s || u,
          S = h === Le.LINEAR;
        return I().createElement("div", {
          className: "gpw"
        }, a(E, function () {
          return o(!r);
        }), r && I().createElement(I().Fragment, null, I().createElement("div", {
          className: "overlay",
          onClick: function () {
            return o(!1);
          }
        }), I().createElement("div", {
          className: "popover"
        }, w && I().createElement("div", {
          className: "controls-wrapper"
        }, I().createElement(He, {
          gradientType: h,
          onGradientTypeChange: O
        }), u && S && I().createElement(le, {
          angle: f,
          setAngle: d,
          size: 28
        })), I().createElement(Fe, de({}, m, {
          palette: t,
          flatStyle: !0
        })))));
      };
    Ze.propTypes = oe;
    const Ye = Ze;
  })(), module.exports = r;
})();